export const printengineMenuDef = [
    {
        name: 'submenu.print_merge_master',
        resource: 'print_merge_master',
        icon: 'fa fa-h-square',
        url: 'print_merge_master',
        breadcrumb: "print_merge_master",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.pullable_object_master',
        resource: 'pullable_object_master',
        icon: 'fa fa-h-square',
        url: 'pullable_object_master',
        breadcrumb: "pullable_object_master",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'submenu.override_template_master',
        resource: 'override_template_master',
        icon: 'fa fa-h-square',
        url: 'override_template_master',
        breadcrumb: "override_template_master",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.pullable_object_grouping',
        resource: 'pullable_object_grouping',
        icon: 'fa fa-h-square',
        url: 'pullable_object_grouping',
        breadcrumb: "pullable_object_grouping",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.print_grid_column_grouping',
        resource: 'print_grid_column_grouping',
        icon: 'fa fa-h-square',
        url: 'print_grid_column_grouping',
        breadcrumb: "print_grid_column_grouping",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.print_style',
        resource: 'print_style',
        icon: 'fa fa-h-square',
        url: 'print_style',
        breadcrumb: "print_style",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.print_segment',
        resource: 'print_segment',
        icon: 'fa fa-h-square',
        url: 'print_segment',
        breadcrumb: "print_segment",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.print_template',
        resource: 'print_template',
        icon: 'fa fa-h-square',
        url: 'print_template',
        breadcrumb: "print_template",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.print_template_html',
        resource: 'print_template_html',
        icon: 'fa fa-h-square',
        url: 'print_template_html',
        breadcrumb: "print_template_html",
        auto_crud: true,
    },
    {
        name: 'menu.print_settings',
        resource: 'print_settings',
        icon: 'fa fa-h-square',
        url: 'print_settings',
        breadcrumb: "print_settings",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.print_template_master',
        resource: 'print_template_master',
        icon: 'fa fa-h-square',
        url: 'print_template_master',
        breadcrumb: "print_template_master",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.print_template_master_html',
        resource: 'print_template_master_html',
        icon: 'fa fa-h-square',
        url: 'print_template_master_html',
        breadcrumb: "print_template_master_html",
        auto_crud: true,
    },
    {
        name: 'menu.print_template_language_mapping',
        resource: 'print_template_language_mapping',
        icon: 'fa fa-h-square',
        url: 'print_template_language_mapping',
        breadcrumb: "print_template_language_mapping",
        auto_crud: true,
        showMenu: true
    },
    {
            name: 'menu.print_label',
            resource: 'print_label',
            icon: 'fa fa-h-square',
            url: 'print_label',
            breadcrumb: "print_label",
            auto_crud: true,
            showMenu: true
    },
    {
        name: 'menu.print_identification',
        resource: 'print_identification',
        icon: 'fa fa-h-square',
        url: 'print_identification',
        breadcrumb: "print_identification",
        auto_crud: true,
    },
    {
        "name": "menu.mis_master_data",
        "resource": "mis_master_data",
        "icon": "fa fa-tag",
        "url": "mis_master_data",
        "auto_crud": true,
        "breadcrumb": "MIS Master Data",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.mis_schedular",
        "resource": "mis_schedular",
        "icon": "fa fa-tag",
        "url": "mis_schedular",
        "auto_crud": true,
        "breadcrumb": "MIS Master Data",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.mis_schedular_account",
        "resource": "mis_schedular_account",
        "icon": "fa fa-tag",
        "url": "mis_schedular_account",
        "auto_crud": true,
        "breadcrumb": "MIS Master Data",
        "check_permission": false,
        "showMenu": true
      },
      {
        name: 'menu.async_downloads',
        resource: 'async_downloads',
        icon: 'fa fa-h-square',
        url: 'async_downloads',
        breadcrumb: "async_downloads",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.print_template_settings',
        resource: 'print_template_settings',
        icon: 'fa fa-h-square',
        url: 'print_template_settings',
        breadcrumb: "print_template_settings",
        auto_crud: true,
        showMenu: true
    }, {
        name: 'menu.print_routing',
        resource: 'print_routing',
        icon: 'fa fa-h-square',
        url: 'print_routing',
        breadcrumb: "print_routing",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.printer_master',
        resource: 'printer_master',
        icon: 'fa fa-h-square',
        url: 'printer_master',
        breadcrumb: "printer_master",
        auto_crud: true,
        showMenu: true
    }
]